module.exports = __webpack_public_path__ + "static/media/spider-web.27b1f992.svg";